import * as React from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import {useBoldInputStyle} from 'components/common/useBoldInputStyle'

export default function NursingInstitutionInput() {
  const createMemberInfo = useFormContext()
  const classes = useBoldInputStyle()
  const {t} = useTranslation()

  return (
    <div className={classes.root}>
      <div className={classes.labelWrapContainer}>
        <p className={classes.inputLabel} style={{padding: '5px 0'}}>
          {t('IOrgNursingInstitutionNumber')}
        </p>
      </div>
      <input
        placeholder={t('IRegisterNursingInstitutionNumber')}
        className={classes.input}
        {...createMemberInfo.register('institutionNo')}
      />
    </div>
  )
}
